import React from 'react';
import { ClickAwayListener, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
const exclusiveInfo = 'Since you were the highest bidder in the auction, this car is only open for you.';

const CustomToolTip = ({ children, open, text = exclusiveInfo, handleClose, placement = 'right' }) => {
    return (
        <ClickAwayListener
            onClickAway={handleClose}>
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={handleClose}
                open={open}
                arrow={true}
                disableFocusListener
                placement={placement}
                disableHoverListener
                disableTouchListener
                title={text}
                classes={{ popper: placement === 'right' && 'w-80 right-0', tooltipPlacementRight: 'ml-6' }}
            >
                {children}
            </Tooltip>
        </ClickAwayListener>
    );
};

CustomToolTip.propTypes = {
    children: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    text: PropTypes.string,
    placement: PropTypes.string
};

export default CustomToolTip;
